import { render, staticRenderFns } from "./scopeForm.vue?vue&type=template&id=11624d8a"
import script from "./scopeForm.vue?vue&type=script&lang=js"
export * from "./scopeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports